import { TARGETS_TABLE_SUCCESS, TARGETS_TABLE_REQUEST, TARGETS_TABLE_FAILURE } from '../../constant';

const initialState = {
  data: [],
  loading: true,
};

const targetsTable = (state = initialState, action) => {
  switch (action.type) {
    case TARGETS_TABLE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case TARGETS_TABLE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case TARGETS_TABLE_FAILURE:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default targetsTable;
